import cloneDeep from 'lodash.clonedeep';
import {action, observable} from 'mobx';
import * as mail from 'js/utils/api/mail';
import checkForm from './check-form';

const initialState = {
  form: {
    company: '',
    unit: '',
    name: '',
    email: '',
    tel: '',
    agree: false,
  },
  error: {
    company: null, // error message text
    unit: null,
    name: null,
    email: null,
    tel: null,
    agree: null,
  },
};

/**
 * Registration Store
 */
export default class RegistrationStore {
  @observable form = cloneDeep(initialState.form);
  @observable error = cloneDeep(initialState.error);
  @observable state = {
    check: false,
    error: false,
    mail: false,
  };

  /**
   * constructor
   */
  constructor() {
  }

  /**
   * clear state
   * @param {boolean} state
   */
  @action clearState() {
    this.state.check = false;
    this.state.error = false;
  }

  /**
   * change check state
   * @param {boolean} state
   */
  @action changeCheckState(state) {
    this.state.check = state;
  }

  /**
   * change error state
   * @param {boolean} state
   */
  @action changeErrorState(state) {
    this.state.error = state;
  }

  /**
   * change mail state
   * @param {boolean} state
   */
  @action changeMailState(state) {
    this.state.mail = state;
  }

  /**
   * update form
   * @param {string} key
   * @param {string} value
   */
  @action updateForm(key, value) {
    this.form[key] = value;
  }

  /**
   * check
   * @return {*}
   */
  @action check() {
    let result = false;

    const error = checkForm(this.form, cloneDeep(initialState.error));
    const check = (Object.keys(error)).some((key) => {
      return error[key];
    });
    if (!check) {
      result = true;
    }

    this.error = error;
    return result;
  }

  /**
   * send mail generator
   * @return {boolean}
   */
  * sendMailGenerator() {
    const params = new URLSearchParams();
    params.append('company', this.form.company);
    params.append('unit', this.form.unit);
    params.append('name', this.form.name);
    params.append('email', this.form.email);
    params.append('tel', this.form.tel);

    const result = yield mail.send(params);

    if (result.error) {
      this.changeErrorState(true);
      throw new Error('send mail error');
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/js/stores/registration/index.js